import {
  Component,
  effect,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
} from "@angular/core";
import { Router } from "@angular/router";
import { QR3ReportsResponse } from "../../../../core/models/dashboard/qr3ReportsResponse";
import { QR2Reports } from "../../../../core/models/dashboard/qr2Reports";
import { YearToYearSummaryDashboardResponseGrid } from "../../../../core/models/reports/yearToYearSummaryDashboardResponseGrid";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { TableColumns } from "../../../../core/models/dashboard/tableColumns";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { DrawerService } from "../../../../core/services/drawer.service";
import { DashboardReport } from "../../../../shared/enums/dashboardReports";
import { LoaderService } from "../../../../core/services/loader.service";
import { GetProjectInvoiceReportRequestDto } from "../../../../core/models/orders/getProjectInvoiceReportRequestDto";
import { HidevalueifzeroPipe } from "../../../../shared/pipes/hidevalueifzero/hidevalueifzero.pipe";
import { PercentagePipe } from "../../../../shared/pipes/percentagesymbol/percentagesymbol.pipe";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { TypeofPipe } from "../../../../shared/pipes/typeof/typeof.pipe";

@Component({
  selector: "jni-dashboard-tables",
  templateUrl: "./dashboard-tables.component.html",
  styleUrls: ["./dashboard-tables.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    // Qr1CompleteComponent,
    // Qr2CompleteComponent,
    // Qr3CompleteComponent,
    // Qr4CompleteComponent,
    // ReadyToBillComponent,
    // ArAgingDetailsReportComponent,
    HidevalueifzeroPipe,
    PercentagePipe,
    HidedynamicsdatePipe,
    TypeofPipe,
  ],
})
export class DashboardTablesComponent implements OnChanges {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  data1: any = [];
  /* eslint-enable @typescript-eslint/no-explicit-any */
  orderDisplayModal = false;
  saleOrderId = "";
  clientDisplayModal = false;
  clientId = "";
  samplePODisplayModal = false;
  ponumber = "";
  projId = "";

  qr1DisplayModal = false;
  qr2DisplayModal = false;
  qr3DisplayModal = false;
  qr4DisplayModal = false;
  qr5DisplayModal = false;
  qr6DisplayModal = false;
  invoiceReviewSummaryDisplayModal = false;
  viewCompleteListText = "View Complete list";
  @Input() qr3Response: QR3ReportsResponse = {} as QR3ReportsResponse;
  @Input() dasbhoardReportState = "";
  @Input() qR2Reports: QR2Reports = {} as QR2Reports;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Input() set data(value: any) {
    if (Array.isArray(value)) {
      this.data1 = value;
    } else {
      this.data1 = [];
    }
  }
  get data() {
    return this.data1;
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */
  @Input() columns!: TableColumns[];
  @Input() showSmallLoader!: boolean;
  @Input() heading = "";
  @Input() redirectCompleteLink = "";
  @Input() displayFooter = true;
  @Input() merchTotal = 0;
  @Input() freightTotal = 0;
  @Input() taxTotal = 0;
  @Input() invTotalSum = 0;
  @Input() totalOutstanding = 0;
  @Input() isQr1YearOverYearDashboardReport = false;
  @Input() isQr2YearOverYearDashboardReport = false;
  @Input() isQr3YearOverYearDashboardReport = false;
  @Input() isQr4YearOverYearDashboardReport = false;
  @Output() toggleModalForTables = new EventEmitter<{
    type: string;
    status: boolean;
  }>();
  @Output() openModalEvent = new EventEmitter();
  yearToYearSummaryDashboardResponseGrid: YearToYearSummaryDashboardResponseGrid =
    {} as YearToYearSummaryDashboardResponseGrid;
  currentDateAndMonth = "";

  constructor(
    private _router: Router,
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _sidebarService: DrawerService,
    private renderer: Renderer2,
    private _orderSummary: OrderSummaryService
  ) {
    effect(() => {
      const value = this._sidebarService.selectedMenu();
      if (value === "dashboard") {
        this.orderDisplayModal = false;
        this.clientDisplayModal = false;
        this.samplePODisplayModal = false;
        this.qr1DisplayModal = false;
        this.qr2DisplayModal = false;
        this.qr3DisplayModal = false;
        this.qr4DisplayModal = false;
        this.qr5DisplayModal = false;
        this.qr6DisplayModal = false;
      }
    });
  }

  ngOnChanges(): void {
    if (
      this.isQr1YearOverYearDashboardReport === true ||
      this.isQr2YearOverYearDashboardReport === true ||
      this.isQr3YearOverYearDashboardReport === true ||
      this.isQr4YearOverYearDashboardReport === true
    ) {
      this.getYearOverYearSummaryDashboardReport();
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  redirect(value: string, field: string, rowData: any, linkField: any) {
    if (
      field == "jobName" ||
      field == "rsmJobName" ||
      field == "salesOrderId" ||
      field == "order" ||
      field == "orderNumber" ||
      field == "salesOrder"
    ) {
      //this._router.navigate(['orders/order-summary/' + value]);
      if (value) {
        this.saleOrderId = value;
        this.orderDisplayModal = true;
        this.openModalEvent.emit({ moduleName: "order", value });
      } else {
        this.saleOrderId = "";
      }
    } else if (
      field == "clientName" ||
      field == "clientD365" ||
      field == "client" ||
      field == "customerAccount"
    ) {
      //this._router.navigate(['clients/active/client-details/' + value]);
      if (value) {
        this.clientId = value;
        this.clientDisplayModal = true;
        this.openModalEvent.emit({ moduleName: "client", value });
      } else {
        this.clientId = "";
      }
    } else if (
      field == "costIn" &&
      linkField === "invoiceReviewSummaryScreen"
    ) {
      if (rowData.orderNumber && rowData.projId) {
        this.saleOrderId = rowData.orderNumber;
        this.projId = rowData.projId;
        this.invoiceReviewSummaryDisplayModal = true;
      }
    } else if (field == "costIn") {
      if (rowData.purchaseOrderNumber) {
        if (value) {
          this.ponumber = value;
          // this._router.navigateByUrl('/samplepo', {
          //   state: value
          // });
          this.samplePODisplayModal = true;
          this.openModalEvent.emit({ moduleName: "samplePO", value });
        }
      }
    } else if (field == "invoice") {
      this.getProjectInvoiceReport(
        value,
        rowData?.invoiceDate ?? rowData?.invDate
      );
      //this.getProjectInvoicePrintPreviewReport(value);
    } else if (field == "freight" || field == "freightSales") {
      this._router.navigate(["orders/freight-charges/" + value]);
    }
  }
  /* eslint-enable @typescript-eslint/no-explicit-any */

  onViewCompleteList() {
    if (this.redirectCompleteLink) {
      if (this.redirectCompleteLink === "quadreport1") {
        // this.qr1DisplayModal = true;
        this.toggleModalForTables.emit({
          type: "qr1DisplayModal",
          status: true,
        });
      } else if (this.redirectCompleteLink === "quadreport2") {
        // this.qr2DisplayModal = true;
        this.toggleModalForTables.emit({
          type: "qr2DisplayModal",
          status: true,
        });
      } else if (this.redirectCompleteLink === "quadreport3") {
        // this.qr3DisplayModal = true;
        this.toggleModalForTables.emit({
          type: "qr3DisplayModal",
          status: true,
        });
      } else if (this.redirectCompleteLink === "quadreport4") {
        // this.qr4DisplayModal = true;
        this.toggleModalForTables.emit({
          type: "qr4DisplayModal",
          status: true,
        });
      } else if (this.redirectCompleteLink === "quadreport5") {
        // this.qr5DisplayModal = true;
        this.toggleModalForTables.emit({
          type: "qr5DisplayModal",
          status: true,
        });
      } else if (this.redirectCompleteLink === "quadreport6") {
        // this.qr6DisplayModal = true;
        this.toggleModalForTables.emit({
          type: "qr6DisplayModal",
          status: true,
        });
      }
      //this._router.navigateByUrl('/dashboard/' + this.redirectCompleteLink);
    }
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getInvoiceReport(invoiceId: string) {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getInvoiceReport(invoiceId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModalForSamplePO() {
    this.samplePODisplayModal = false;
  }

  closeModalForqr3() {
    this.qr3DisplayModal = false;
  }

  closeModalForqr2() {
    this.qr2DisplayModal = false;
  }

  closeModalForqr4() {
    this.qr4DisplayModal = false;
  }

  closeModalForqr1() {
    this.qr1DisplayModal = false;
  }

  closeModalForqr5() {
    this.qr5DisplayModal = false;
  }

  closeModalForqr6() {
    this.qr6DisplayModal = false;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  getProjectInvoiceReport(invoiceNumber: string, invoiceDate: string) {
    this._loaderService.setLoaderState(true);
    const reportObject = {
      InvoiceDate: invoiceDate,
      ProjectInvoiceId: invoiceNumber,
    } as GetProjectInvoiceReportRequestDto;
    this._orderSummary.getProjectInvoiceReport(reportObject).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data?.reportBase64String) {
          const blob = this.b64toBlob(
            res.data.reportBase64String,
            "application/pdf"
          );
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else {
          this._toastr.error("Error", res.message);
          return;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  public get DashboardReport(): typeof DashboardReport {
    return DashboardReport;
  }

  viewCompleteListHeading() {
    if (this.heading === "AR Aging Dashboard Report") {
      return "View Detail Report";
    } else {
      return "View Complete list";
    }
  }

  closeModalForInvoiceReview() {
    this.invoiceReviewSummaryDisplayModal = false;
  }

  getYearOverYearSummaryDashboardReport() {
    if (!this.yearToYearSummaryDashboardResponseGrid.currentDate) {
      this._dashboardService.getYearOverYearDashboardReport().subscribe({
        next: res => {
          if (res?.data && res?.status === "Success") {
            this.yearToYearSummaryDashboardResponseGrid = res.data;
            this.currentDateAndMonth =
              new Date(
                this.yearToYearSummaryDashboardResponseGrid.currentDate
              ).getMonth() +
              1 +
              "/" +
              new Date(
                this.yearToYearSummaryDashboardResponseGrid.currentDate
              ).getDate();
          }
        },
        error: () => {
          //ToDo List
        },
      });
    }
  }

  setTigerTargetValue(from: number, to: number) {
    const gpYear = this.yearToYearSummaryDashboardResponseGrid.gpYear1 ?? 0;
    if (gpYear >= from && gpYear <= to) {
      return Number((to - (gpYear ?? 0)).toFixed(2));
    } else if (gpYear < from) {
      return Number((from - (gpYear ?? 0)).toFixed(2));
    }
    return 0;
  }
}
